import {useQuery, gql} from "@apollo/client";

var Appointment_LIST = gql`
query MyQuery {
  appointmentCommittee (where: {localization: {culture_starts_with: "fa"}}){
    displayText
    email {
      html
    }
    fax {
      html
    }
    image {
      urls(first: 1)
    }
    level
    phoneNumber {
      html
    }
    position {
      html
    }
  }
}
`



export const useAppointmentCommittee = () => {
const {error, loading, data} = useQuery(Appointment_LIST);

return {
  error, data, loading
};
} 